import React from 'react';

import Carousel from '../../components/PageSections/Carousel/Carousel';
import VideoCarousel from '../../components/PageSections/Carousel/VideoCarousel';
import PageSection from '../../components/PageSections/PageSection';
import { getThemeClass } from '../textTools';

export const ContentfulSectionCarousel = (section, i, styles, onCtaClick) => {
  const themeClass = getThemeClass(section.colorTheme?.themeName);
  const isVideoCarousel = !!section.videoUrl;
  let carousel = (
    <Carousel
      heading={section.heading}
      eyebrowText={section.eyebrowText}
      accentColor={section.accentColor}
      flipped={section.imageSide === 'true'}
      items={section.cards}
      onCta={onCtaClick}
      ctaLabel={section.ctaLabel}
      ctaUrl={section.ctaUrl}
    />
  );
  if (isVideoCarousel) {
    carousel = (
      <VideoCarousel
        heading={section.heading}
        eyebrowText={section.eyebrowText}
        accentColor={section.accentColor}
        flipped={section.imageSide === 'true'}
        items={section.cards}
        onCta={onCtaClick}
        ctaLabel={section.ctaLabel}
        ctaUrl={section.ctaUrl}
        videoUrl={section.videoUrl}
      />
    );
  }
  return (
    <PageSection
      key={i}
      moderate
      wide
      fullBleed
      className={[styles[section.backgroundColor], themeClass].join(' ')}
      data-analytics-section={'carousel-wrapper'}
    >
      <div className={styles.carousel}>{carousel}</div>
    </PageSection>
  );
};
